import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { OpenFeature } from '@openfeature/angular-sdk';

export function ensureFeatureFlag(featureFlag: string, redirectTo?: string): CanActivateFn {
  return async (): Promise<boolean | UrlTree> => {
    const router = inject(Router);

    const client = OpenFeature.getClient();
    const isFeatureEnabled = client.getBooleanValue(featureFlag, false);

    if (!isFeatureEnabled && redirectTo) {
      return router.parseUrl(redirectTo);
    }

    if (!isFeatureEnabled) {
      return router.parseUrl('/pagina-niet-gevonden');
    }

    return true;
  };
}
